import {request} from '@/helpers/apiClient'
import {UPLOAD_IMAGES_CONFIG} from '@/utils/constants/apiConfig/uploadImagesConfig'

export const uploadImagesService = options => {
  return request(UPLOAD_IMAGES_CONFIG.UPLOAD_IMAGES(), options)
}
